<div class="d-none d-print-block">
  <p style="padding-left: 30px !important; padding-top: 30px !important">
    <i class="fas fa-exclamation-circle fa-fw"></i> Please go to your student portal to participate in this discussion
  </p>
</div>

<div class="pl-2">
  <ebs-offline-message [isOffline]='isOffline' [offlineMessage]='offlineMessage'></ebs-offline-message>
</div>

@if (!isOffline && courseCode) {
  <div class="card-body discussion-wrapper">
    @if (showError) {
      <ebs-notification-multiple [notifications]="notifications"></ebs-notification-multiple>
    }
    <div class="discussion-create-wrapper">
      @if (!showReply) {
        <div class="row">
          <div class="col-12 reply-like-button">
          </div>
        </div>
      }
      <div class="row mb-2">
        <div class="col-12">
          @if (!isOffline && currentUser) {
            <ebs-wysiwyg [parentIsMyPost]="false" [editorText]="''" [buttonText]="'Post'"
              [discussionId]="discussionId" [courseCode]="courseCode" [currentUser]="currentUser"
              (addPostEvent)="handleNewPost($event)" [placeholderText]="'Create new post...'">
            </ebs-wysiwyg>
          }
        </div>
      </div>
    </div>
    <div class="no-post-message pl-2">
      @if (showFirstPostMessage() && !isOffline) {
        <ebs-message-simple [iconCssClasses]="'text-info fa fa-fw fa-exclamation-circle'" [textCssClasses]="'text-info'"
          [wrapperCssClasses]="''" [displayMessage]="'Be the first to post a message'"
          >
        </ebs-message-simple>
      }
    </div>
    @if (loadingPosts) {
      <ebs-spinner [spinnerMessage]="'loading posts'"></ebs-spinner>
    }
    <a class="discussion-anchor" href="#" id="discussion-{{discussionId}}"></a>
    @for (post of posts; track post; let i = $index) {
      <div>
        <!--posts-->
        @if (selectedPost) {
          <div id="single-post-filter" class="col-12" style="padding: 0;">
            <div class="alert alert-warning alert-discussion" role="alert"><i
            class="fa fa-lg fa-exclamation-circle fa-fw"></i> Viewing post from {{selectedPost.person.name}}
            <button class="btn btn-primary btn-sm ml-3" (click)="removeSelectedPost($event)">Show full discussion</button>
          </div>
        </div>
      }
      @if (currentUser) {
        <ebs-discussion-postorreply-item [defaultPostShowHideStatus]="!displayParticularPostOrReply()"
          [currentUser]="currentUser" [discussionPostOrReplyItem]="post" [isAReply]="false"
          (bubbleReplacePostUpdatedLikeEvent)="handleUpdatedPost($event)"
          (deletedPostOrReplyEvent)="handleDeletedPostOrReply($event)" [postDisplayIndex]="i">
        </ebs-discussion-postorreply-item>
      }
      <!--replies... replies have an extra postdetails that is passed down the chain-->
      <div>
        @for (reply of post.replies; track reply; let j = $index) {
          <div>
            @if (currentUser) {
              <ebs-discussion-postorreply-item [defaultPostShowHideStatus]="!displayParticularPostOrReply()"
                [currentUser]="currentUser" [discussionPostOrReplyItem]="reply" [isAReply]="true"
                (bubbleReplacePostUpdatedLikeEvent)="handleUpdatedPost($event)"
                (deletedPostOrReplyEvent)="handleDeletedPostOrReply($event)" [postDetails]="post">
              </ebs-discussion-postorreply-item>
            }
            @if ((j + 1) === post.replies.length) {
              <div class="reply-row">
                @if (!isOffline && currentUser) {
                  <ebs-wysiwyg [parentIsMyPost]="post.isMyEntry" [editorText]="''"
                    [buttonText]="'Post'" [discussionId]="discussionId" [courseCode]="courseCode" [currentUser]="currentUser"
                    (updatePostEvent)="handleUpdatedPost($event)" [placeholderText]="'Create new reply...'"
                    [postDetails]="post">
                  </ebs-wysiwyg>
                }
              </div>
            }
          </div>
        }
        <!--still need an editor if no replies-->
        @if (!post.replies || post.replies.length === 0) {
          <div class="reply-row">
            @if (!isOffline && currentUser) {
              <ebs-wysiwyg [parentIsMyPost]="post.isMyEntry" [editorText]="''"
                [buttonText]="'Post'" [discussionId]="discussionId" [courseCode]="courseCode" [currentUser]="currentUser"
                (updatePostEvent)="handleUpdatedPost($event)" [placeholderText]="'Create new reply...'" [postDetails]="post">
              </ebs-wysiwyg>
            }
          </div>
        }
      </div>
    </div>
  }
  @if (loadingMorePosts) {
    <ebs-spinner [spinnerMessage]="'getting more posts'"></ebs-spinner>
  }
  <!-- Load More -->
  @if (postsLoadedLessThanTotal() && !isOffline) {
    <div class="row mt-3">
      <div class="col-12 col-sm-6 offset-sm-3 text-center">
        <span (click)="loadMorePosts()" class="btn btn-primary btn-sm">
          <i class="fas fa-arrow-down"></i> Load more posts
        </span>
      </div>
    </div>
  }
  @if (postsLoaded() && !displayParticularPostOrReply()) {
    <div class="row">
      <div class="col-12 col-sm-6 offset-sm-3 text-center loaded-style">
        Loaded {{posts.length}} of {{totalItems }}
      </div>
    </div>
  }
</div>
}